import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h3>Error 404: Page Not Found</h3>
        </div>
    );
};

export default NotFound;